exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!../../styles/foundations.css"), "");

// module
exports.push([module.id, "\n.stale-icon[data-v-4cf21eab] {\n  color: var(--amber-400);\n  font-size: 12px;\n  cursor: default;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n}\n", ""]);

// exports
